import { DDEApi } from '@img-arena/consoles-api-dde'
import { useAuthStore } from '@/stores/useAuthStore'

import { logoutOnUnauthorized } from './interceptors/logoutOnUnauthorized'
// In here there is an instance of DDE Api definition
// Please use it in each place of the application for any api call to DDE from ops-console

export const ddeApi = new DDEApi(
  {
    baseURL: `${import.meta.env.VITE_DDE_HTTPAPI}/`,
    getToken: () => useAuthStore.getState().token
  },
  logoutOnUnauthorized
)
